<template>
  <component
    :is="selectedTemplate.template"
    v-if="selectedTemplate"
  />
</template>

<script>
  import { get } from 'lodash'
  import { getIconPack } from 'app/views/search/collections'
  import v7SaleMixin from 'app/views/v7SaleMixin'

  import { IconPackMixin } from './mixins.js'
  import TemplatePack from './templates/TemplatePack'
  import TemplateHidden from './templates/TemplateHidden'

  export default {
    name: 'IconPackLanding',

    components: {
      TemplatePack,
      TemplateHidden
    },

    mixins: [IconPackMixin, v7SaleMixin],

    provide() {
      return {
        iconPack: () => this.iconPack,
        isLoading: () => this.isLoading,
        isPrereleased: () => this.iconPack?.status?.toLowerCase() === 'prereleased',
        isReleased: () => this.iconPack?.status?.toLowerCase() === 'released',
        hasAccessToIconPack: () => this.hasAccessToIconPack,
        requiredPlanLevelForAccess: () => this.requiredPlanLevelForAccess
      }
    },

    data() {
      return {
        iconPack: null,
        isLoading: true,
        selectedTemplate: null
      }
    },

    computed: {
      iconPackName() {
        return decodeURIComponent(this.$route.path.split('/').pop())
      },

      accountPlan() {
        return get(this.$account, ['subscription', 'plan'], null)
      },

      hasAccessToIconPack() {
        if (this.$account) {
          // TODO V7: Remove the plus plan check once the database is populated with icon pack data
          // the else block will handle all cases once the database is populated
          if (['FA-LITE-PLUS', 'FA-STANDARD-PLUS', 'FA-MAX-PLUS'].includes(this.accountPlan.sku)) {
            return true
          } else {
            // Check that all iconPack familyStyles are in the accountPlan
            return this.iconPack.familyStyles.every((familyStyle) =>
              this.accountPlan.iconCollection.familyStyles.some((fs) => fs.family === familyStyle.family && fs.style === familyStyle.style)
            )
          }
        } else {
          return false
        }
      },

      requiredPlanLevelForAccess() {
        return this.iconPack?.licenseType === 'FAPS' ? 'Pro' : 'Pro+'
      }
    },

    watch: {
      $route: 'fetchIconPack',
      iconPack: 'updateTemplate'
    },

    created() {
      this.fetchIconPack()
    },

    methods: {
      fetchIconPack() {
        this.isLoading = true

        try {
          this.iconPack = getIconPack(this.iconPackName, 7) || null

          if (!this.iconPack?.name) {
            this.iconPack = null
            this.selectedTemplate = {
              template: TemplateHidden
            }
            return
          }

          this.updateTemplate()
        } catch (error) {
          this.iconPack = null
          this.selectedTemplate = {
            template: TemplateHidden
          }
        } finally {
          this.isLoading = false
        }
      },

      updateTemplate() {
        if (!this.iconPack || !this.isIconPackPagesFeatureOn ) {
          this.selectedTemplate = {
            template: TemplateHidden
          }
          return
        }

        this.selectedTemplate = {
          template: TemplatePack
        }
      }
    }
  }
</script>
